<template>
  <Modal
    :value="value"
    :hasFooter="true"
    :warning="warningText"
    width="auto"
    minWidth="961px"
    subtitle="Confira os dados que serão atualizados"
    ref="modal"
    class="modal-component"
    @modal-confirm="confirmModal"
    @modal-cancel="cancelModal"
  >
    <template #body-content>
      <div
        v-if="absoluteRatesRows.length > 0 && formFields.dates.length > 0"
        class="body-content"
      >
        <!-- CABECALHO -->
        <div class="body-content__heading">
          <Heading
            class="body-content__heading body-content__heading--title"
            level="1"
          >
            {{ hotel.nome }}
          </Heading>
          <div class="body-content__heading body-content__heading--subtitle">
            <Heading level="2">
              Quais valores serão atualizados?
            </Heading>
            <Paragraph
              v-if="formFields.rate && formFields.rate.length === 1"
              font-size="small"
              >{{ formFields.rate[0].text }}</Paragraph
            >
            <Paragraph v-else-if="formFields" font-size="small">{{
              formFields.selectedRate.text
            }}</Paragraph>
          </div>
        </div>

        <div v-if="formFields" class="mb-3">
          <Chip
            v-for="(date, i) in formFields.dates"
            :key="`${date.start}-${date.end}-${i}`"
          >
            {{ formatDate(new Date(date.rawStart), 'dd MMM yyyy') }} -
            {{ formatDate(new Date(date.rawEnd), 'dd MMM yyyy') }}
          </Chip>
        </div>
      </div>

      <SimpleTable
        v-if="
          formFields &&
            formFields.dates.length > 0 &&
            absoluteRatesRows.length > 0 &&
            absoluteRatesHeaders.length > 0
        "
        class="simple-table"
        :columns="absoluteRatesHeaders"
        :rows="absoluteRatesRows"
        :numFormat="true"
        :ignoreNumFormatCols="['roomCode']"
      >
        <template #roomCode="{column}">
          <td class="justify-content-start">{{ column.text }}</td>
        </template>

        <template #row-roomCode="{ rowItem }">
          <td class="text-left flex-room ">
            <div class="simple-table--room">
              <span class="font-weight-bold">{{ rowItem['roomCode'] }} - </span>
            </div>
            <span class="font-weight-normal simple-table--base">
              {{ rowItem['selectedWeekDays'] }}
            </span>
          </td>
        </template>

        <template #row-desconto="{ rowItem }">
          <td class="simple-table--cell">
            <span v-if="rowItem.desconto > 0" class="discount">
              {{ `-${rowItem.desconto}%` }}
            </span>
            <span v-else-if="rowItem.desconto == 0" class="discount">
              {{ '0%' }}
            </span>
            <span v-else>-</span>
          </td>
        </template>

        <template
          v-for="pax in paxSlots"
          v-slot:[`row-${pax.value}`]="{ rowItem }"
        >
          <td :key="pax.value" class="simple-table--cell">
            <span v-if="!rowItem[pax.value] && +rowItem[pax.value] !== 0"
              >-</span
            >
            <span v-else
              >{{ rowItem[pax.value] | numFormat('0.00') }}
              {{ getCurrency }}</span
            >
          </td>
        </template>
      </SimpleTable>

      <div class="body-content">
        <!-- Disponibilidade Letsbook -->
        <div v-if="allotments.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            Disponibilidade Let’s Book
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false },
              {
                label: 'Disponibilidade (por dia)',
                value: 'disponibilidade',
                tooltip: false
              }
            ]"
            :rows="allotmentData"
            :highlightCols="['disponibilidade']"
          />
        </div>

        <!-- Fechar ou abrir vendas -->
        <div v-if="vendasFechadasData.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            Fechar ou abrir vendas
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false },
              { label: 'Tipo', value: 'vendas', tooltip: false }
            ]"
            :rows="vendasFechadasData"
            :highlightCols="['vendas']"
          />
        </div>

        <!-- Mínimo noites -->
        <div v-if="minimoNoitesData.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            Mínimo de noites
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false },
              { label: 'Tipo', value: 'tipoMinimoNoites', tooltip: false },
              {
                label: 'Número de noites',
                value: 'numeroNoites',
                tooltip: false
              }
            ]"
            :rows="minimoNoitesData"
            :highlightCols="['vendas']"
          />
        </div>

        <!-- CTA -->
        <div v-if="ctaData.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            CTA
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false }
            ]"
            :rows="ctaData"
          />
        </div>

        <!-- CTD -->
        <div v-if="ctdData.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            CTD
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false }
            ]"
            :rows="ctdData"
          />
        </div>
      </div>
    </template>

    <template #actions>
      <!-- CANCELAR -->
      <Button
        size="large"
        class="modal-component--content-button"
        layout="outline"
        @click="cancelModal"
        >Cancelar</Button
      >

      <!-- CONFIRMAÇÃO -->
      <Button
        size="large"
        class="modal-component--content-button"
        @click="confirmModal"
      >
        Confirmar
      </Button>
    </template>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseISO } from 'date-fns'
import Modal from '@/components/_base/patterns/Modal'
import Heading from '@/components/_base/elements/Heading'
import Chip from '@/components/_base/patterns/Chip'
import Paragraph from '@/components/_base/elements/Paragraph'
import CleanTable from '@/components/_base/patterns/CleanTable'
import SimpleTable from '@/components/_base/patterns/SimpleTable'
import Button from '@/components/_base/elements/Button'
import hotelRatesConfirmationModalMixin from '@/mixins/hotelRatesConfirmationModalMixin'

/**
 * Componente para apresentar a modal de confirmação da tarifa absoluta e suas restrições
 */
export default {
  name: 'ConfirmationModal',
  mixins: [hotelRatesConfirmationModalMixin],
  components: {
    Modal,
    Heading,
    Chip,
    Paragraph,
    CleanTable,
    SimpleTable,
    Button
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    restrictions: {
      type: Object,
      default: () => {}
    },
    allotments: {
      type: Array,
      default: () => []
    },
    formFields: {
      type: Object,
      default: () => null
    },
    rooms: {
      type: Array,
      default: () => []
    },
    selectedGuestsOptions: {
      type: Array,
      default: () => []
    },
    /** Dados do hotel */
    hotel: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      allotmentData: [],
      absoluteRatesHeaders: [],
      absoluteRatesRows: [],
      ctdData: [],
      ctaData: [],
      vendasFechadasData: [],
      minimoNoitesData: [],
      rates: {},
      weekdays: [
        { text: 'Domingo', value: 1 },
        { text: 'Segunda', value: 2 },
        { text: 'Terça', value: 3 },
        { text: 'Quarta', value: 4 },
        { text: 'Quinta', value: 5 },
        { text: 'Sexta', value: 6 },
        { text: 'Sábado', value: 7 }
      ],
      /** Texto de aviso para quando existirem valores 0 */
      warningText: ''
    }
  },
  computed: {
    ...mapGetters('hotel', ['getCurrency', 'getCurrencySymbol']),
    paxSlots() {
      return this.absoluteRatesHeaders.filter(
        (item) => item.value !== 'roomCode' && item.value !== 'desconto'
      )
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.loadingData()
        } else {
          this.warningText = ''
        }
      }
    }
  },
  methods: {
    cancelModal() {
      this.$emit('cancelModal')
      /** Fecha a modal */
      this.$emit('input', false)
    },
    confirmModal() {
      this.$emit('confirmModal')
      /** Fecha a modal */
      this.$emit('input', false)
    },
    loadingData() {
      /** Monta dados de allotment */
      if (this.allotments.length > 0) {
        this.allotmentData = this.allotments.map((restriction) => {
          const obj = {
            periodo: `${this.formatDate(
              parseISO(restriction.dataInicial),
              'dd MMM yyyy'
            )} - ${this.formatDate(
              parseISO(restriction.dataFinal),
              'dd MMM yyyy'
            )}`,
            dia: this.formatArrayToString(
              this.weekdays
                .filter((w) => restriction.diasSemana.includes(w.value))
                .flatMap((w) => w.text)
            ),
            quartos: restriction.quartos
              .map((item) => item.codigo)
              .reduce((acc, curr) => {
                const found = this.rooms.find((room) => room.codigo === curr)

                if (found) {
                  acc.push(found.nome)
                }

                return acc
              }, [])
              .join(', '),
            disponibilidade: restriction.quartos[0].allotment
          }

          return obj
        })
      }

      /** Monta dados de CTA para a modal de confirmação */
      if (this.restrictions) {
        this.ctaData = []
        if (this.restrictions.CTA) {
          this.ctaData = this.restrictions.CTA.map((restriction) => {
            const obj = {
              periodo: `${this.formatDate(
                parseISO(restriction.dataInicial),
                'dd MMM yyyy'
              )} - ${this.formatDate(
                parseISO(restriction.dataFinal),
                'dd MMM yyyy'
              )}`,
              dia: this.formatArrayToString(
                this.weekdays
                  .filter((w) => restriction.diasSemana.includes(w.value))
                  .flatMap((w) => w.text)
              ),
              quartos: this.getSelectedRoomNames(restriction)
            }

            return obj
          })
        }
        /** Monta dados de CTD para a modal de confirmação */
        this.ctdData = []
        if (this.restrictions.CTD) {
          this.ctdData = this.restrictions.CTD.map((restriction) => {
            const obj = {
              periodo: `${this.formatDate(
                parseISO(restriction.dataInicial),
                'dd MMM yyyy'
              )} - ${this.formatDate(
                parseISO(restriction.dataFinal),
                'dd MMM yyyy'
              )}`,
              dia: this.formatArrayToString(
                this.weekdays
                  .filter((w) => restriction.diasSemana.includes(w.value))
                  .flatMap((w) => w.text)
              ),
              quartos: this.getSelectedRoomNames(restriction)
            }

            return obj
          })
        }

        /**Monta vendas fechadas */
        this.vendasFechadasData = []
        if (this.restrictions.vendasFechadas) {
          this.restrictions.vendasFechadas.forEach((restriction) => {
            this.vendasFechadasData.push({
              periodo: `${this.formatDate(
                parseISO(restriction.dataInicial),
                'dd MMM yyyy'
              )} - ${this.formatDate(
                parseISO(restriction.dataFinal),
                'dd MMM yyyy'
              )}`,
              vendas: restriction.vendasFechadas
                ? 'Vendas fechadas'
                : 'Vendas abertas',
              dia: this.formatArrayToString(
                this.weekdays
                  .filter((w) => restriction.diasSemana.includes(w.value))
                  .flatMap((w) => w.text)
              ),
              quartos: this.getSelectedRoomNames(restriction)
            })
          })
        }

        /** Monta mínimo de noites */
        this.minimoNoitesData = []
        if (this.restrictions.minimoNoites) {
          this.restrictions.minimoNoites.forEach((restriction) => {
            this.minimoNoitesData.push({
              periodo: `${this.formatDate(
                parseISO(restriction.dataInicial),
                'dd MMM yyyy'
              )} - ${this.formatDate(
                parseISO(restriction.dataFinal),
                'dd MMM yyyy'
              )}`,
              dia: restriction.diasSemana
                ? this.formatArrayToString(
                    this.weekdays
                      .filter((w) => restriction.diasSemana.includes(w.value))
                      .flatMap((w) => w.text)
                  )
                : '-',
              tipoMinimoNoites:
                restriction.tipoMinimoNoites === 1
                  ? 'Chegando em'
                  : 'Passando por',
              numeroNoites: restriction.numeroNoites,
              quartos: this.getSelectedRoomNames(restriction)
            })
          })
        }
      }
      /**
       * monta tabela com dados atualizados da
       * tarifa absoluta para popular a modal de confirmação
       */
      if (this.formFields) {
        const rows = []
        this.formFields.editedRates.forEach((editedRate) => {
          editedRate.rules.forEach((rule) => {
            rows.push(rule)
          })
        })

        if (rows.length > 0) {
          rows.forEach((row) => {
            /** Remove os valores que são nulos */
            Object.getOwnPropertyNames(row).forEach((val) => {
              if (row[val] === null) {
                delete row[val]
              }

              /** Se algum valor for 0 seta o aviso */
              if (row[val] === 0 && !(typeof row.desconto !== 'undefined')) {
                this.warningText = `Você está cadastrando valores <strong>${this.getCurrencySymbol} 0,00</strong> em alguns quartos.`
              }
            })

            if (row.selectedWeekDays.length > 0) {
              row.selectedWeekDays = this.formatArrayToString(
                row.selectedWeekDays.map((week) => week.text.slice(0, 3))
              )
            }

            row.roomCode = this.formatArrayToString(
              this.rooms
                .filter((g) => row.roomCode === g.codigo)
                .flatMap((g) => g.nome)
            )
          })

          /** Filtra apenas os com dias e valores selecionados */
          this.absoluteRatesRows = rows.filter(
            (item) =>
              item.selectedWeekDays.length > 0 && Object.keys(item).length > 2
          )

          this.absoluteRatesHeaders = []

          const headers = [...this.selectedGuestsOptions]

          this.absoluteRatesHeaders.push(
            { text: 'Quartos', value: 'roomCode' },
            { text: 'Desconto', value: 'desconto' }
          )

          headers.forEach((item) => {
            this.absoluteRatesHeaders.push({
              text: item.text,
              value: item.value
            })
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-table {
  .discount {
    color: $error;
  }

  &--cell {
    padding: 0.8em 0;
  }

  &--column {
    width: 100%;
    display: flex;
    padding: 0;
    justify-content: flex-end;
  }

  &--room {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: max-content;
    margin-right: 5px;
    color: $gray-darkest;
  }

  &--content {
    &-button {
      width: 160px;

      & + & {
        margin-left: 12px;
      }
    }
  }

  .flex-room {
    display: flex;
    white-space: nowrap;
  }
}

.body-content {
  padding: 35px 35px 20px 35px;

  &__heading {
    margin-bottom: 20px;
    &--title {
      font-size: font-size('size-x-large');
      margin-bottom: 32px;
    }
    &--subtitle {
      display: flex;
      align-items: center;
      gap: 8px;

      h2,
      p {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
